<template>
  <div class="host">
    <MerchantLogo class="merchant-logo size-full place-self-center" />

    <div v-if="steps.length" class="vc-stepper-container place-self-center">
      <UIStepper :steps="steps" />
    </div>

    <div class="page-exit z-10 max-xl:mr-4">
      <FlowExitButton v-if="showExitTrigger" @exit="exit" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import MerchantLogo from "./MerchantLogo.vue"
  import UIStepper from "@ui-kit/components/stepper"
  import { useStepperSteps } from "@versatile-credit-apply/components"
  import { computed } from "vue"
  import { useRoute } from "vue-router"
  import { FlowExitButton } from "@versatile-credit-apply/components/session"
  import { useExitFlow } from "@versatile-credit-apply/composition"
  import {
    useCurrentProviderKey,
    useProviderI18n,
  } from "@versatile-credit-apply/sdk"

  const providerKey = useCurrentProviderKey()
  const steps = useStepperSteps(useProviderI18n(providerKey))

  const route = useRoute()
  const showExitTrigger = computed(() => {
    return route.meta.exitTrigger !== false
  })

  const exitFlow = useExitFlow()
  const exit = () => exitFlow("canceled")
</script>

<i18n lang="yaml" locale="en">
stepper:
  steps:
    applicant:
      label: Applicant Info
    decision:
      label: Decision
    terms:
      label: Disclosures
</i18n>

<style scoped>
  @reference "@/main.css";

  .host {
    @apply grid;
    @apply pb-4 xl:pb-0;
    @apply xl:h-full;

    grid-template:
      "logo stepper exit" max-content
      / minmax(max-content, 1fr) minmax(max-content, 1fr) 1fr;

    gap: 0.5rem;
    align-items: center;
  }

  .host .vc-stepper-container {
    grid-area: stepper;
  }

  .host .page-exit {
    grid-area: exit;
    margin-left: auto;
  }

  .host :deep(#merchant-logo) {
    @apply max-h-[40px] md:max-h-[50px];
    @apply xl:max-w-[350px];
  }

  @variant xl {
    .host {
      grid-template:
        "logo" max-content
        "stepper" 1fr
        / 1fr;

      gap: 0.25rem;
      align-items: unset;
      justify-items: center;
    }

    .host .vc-stepper-container {
      place-self: center;

      display: flex;
      height: 100%;
      max-height: 400px;
    }

    .host .page-exit {
      margin-left: 0;
      position: absolute;

      top: 3rem;
      right: 5rem;
    }
  }
</style>
